import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface Props {
  to?: string;
  label: string;
  /** When true, uses browser history back instead of navigating to `to`. */
  history?: boolean;
  className?: string;
}

// Consistent back-navigation link for any page that's drilled into from another.
// Renders a chevron + label, brand color, hover underline. Use this everywhere
// instead of bare "←" arrows or inline anchors.
export default function BackLink({
  to,
  label,
  history = false,
  className = ""
}: Props) {
  const navigate = useNavigate();

  const inner = (
    <span
      className={`inline-flex items-center gap-1.5 text-sm font-medium text-(--ds-primary) hover:underline transition-colors ${className}`}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
      {label}
    </span>
  );

  if (history || !to) {
    return (
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="appearance-none bg-transparent border-0 p-0 cursor-pointer"
      >
        {inner}
      </button>
    );
  }
  return <Link to={to}>{inner}</Link>;
}
